var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"7EARR9ZBq-s1yO9MKccYZ"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

Sentry.init({
    // Access the DSN using the public prefix
    dsn: "https://e4deefd35b2a5563c66ceb1bd5136442@o4509875443662848.ingest.de.sentry.io/4510239161647184",
    debug: true,
    // Example: Set your performance sampling rate for client-side code
    tracesSampleRate: 0.2,
    environment: process.env.HOST === "https://app.tryshophub.com" ? "production" : "development"

    // Optional: Add session replay configuration
    // replaysSessionSampleRate: 0.1, 
    // replaysOnErrorSampleRate: 1.0,
});